<template>
  <div class="brochure">
    <div class="brochure__image">
      <picture>
        <img :src="`${brochure.imageUrl}?format=webp`" :alt="brochure.name" loading="lazy"/>
      </picture>
    </div>
    <h4 class="brochure__title">{{brochure.name}}</h4>
    <div class="brochure__code">{{brochure.code}}</div>
    <p class="brochure__description">{{brochure.description}}</p>
    <div class="brochure__actions">
      <div v-if="brochure.canPost" class="brochure__post default-checkbox default-checkbox--alt">
        <label>
          <input type="checkbox" v-model="selected" />
          <span class="checkbox__label">Order by post</span>
        </label>
      </div>
      <a
        v-if="brochure.canDownload"
        ref="modal"
        class="brochure__online"
        href="#popup"
        @click="$emit('brochureSelected', brochure)">
        View online
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['brochure'],
  computed: {
    selected: {
      get() {
        return this.brochure.selected;
      },
      set(value) {
        this.$store.commit('brochureRequest/toggleSelected', this.brochure);
      }
    }
  },
  created() {
    this.$nextTick(() => {
      const e = this.$refs.modal;
      $(e).magnificPopup({
        type: 'inline',
        midClick: true 
      });
    });
  }
};
</script>